/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (dashboardLayouts) => ({
	type: actions.DASHBOARD_LAYOUTS_RECEIVE,
	payload: { dashboardLayouts },
});
